import _ from 'lodash'
/**
 * Extend the question object with state data:
 * - revealed status
 * - log
 * @param {object} question 
 * @param {object} gameState 
 */
const extendQuestionWithState = (question, gameState) => {
  // check for revealed status
  question.revealed = 0

  if (
    gameState.game.revealed 
    && gameState.game.revealed.includes(question.question_id)
  ) {
    question.revealed = 1
  }

  // Add the question log if any
  if (gameState.question_log) {
    const log = gameState.question_log.find(questionLog => questionLog.question_id === question.question_id)
    if (log) {
      question.log = log
    }
  }

  return question
}

/**
 * Create the current step from the gameStage and gameState
 * @param {object} gameState
 * @param {object} gameStage
 * @return {object} currentStep
 */
const currentStep = (gameState, gameStage) => {
  const segments = gameStage.game.segments.filter(
    s => s.segment_id === gameState.game.step.segment_id
  )

  let segment = null
  // This segment is in the game object multiple times
  // so use the index to find the current one.
  if (segments.length !== 1) {
    const segmentIndex = findSegmentIndexByStepIndex(gameState.game.step, segments)
    segment = gameStage.game.segments.find(
      s => s.index === segmentIndex
    )
  } else {
    [segment = null] = segments
  }

  // the current question
  let question

  // this is a question
  if (gameState.game.step.type === 'question') {
    question = segment.questions.find(
      (q) => q.question_id === gameState.game.step.question_id
    )
  } else {
    // this is a segment, get the first question
    [question] = segment.questions
  }

  // check for revealed status
  question =  extendQuestionWithState(question, gameState)

  return {
    segment,
    question,
    step: gameState.game.step,
  }
}

/**
 * Find the current foreplay step by index
 * @param {object} gameStage 
 * @param {number} index
 */
const findForeplayStepByIndex = (gameStage, index) => {
  // the current segment
  const segment = gameStage.foreplay.segments.find(
    (s) => s.index === index
  )

  let question

  // Return when current step is a segment
  if (segment) {
    // Grab the first question from segment
    question = segment.questions[0]
    
    return {
      segment,
      question,
      step: {
        index,
      },
    }
  }

  // Current step is a question

  // Find the question thro the segments
  question = _(gameStage.foreplay.segments)
    .thru((coll) => _.union(coll, _.map(coll, 'questions') || []))
    .flatten()
    .find({ index })

  // Grab the question's segment
  const segmentId = question.segment_id

  const questionSegment = gameStage.foreplay.segments.find(
    (s) => s.segment_id === segmentId
  )

  return {
    segment: questionSegment,
    question,
    step: {
      index,
    },
  }
}

/**
 * Find the parent segment's index for the question type steps
 * @param {object} step - the gameState.game.step
 * @param {array} segments
 * @returns {integer} segmentIndex
 */
const findSegmentIndexByStepIndex = (step, segments) => {
  if (step.type === 'segment') {
    return step.index
  }
  // find the question's parent segment's index
  return (segments.map(segment => ({
      segmentIndex: segment.index,
      questionIndexes: segment.questions.map(q => q.index)
    })
  ).find(si => si.questionIndexes.includes(step.index)) || {}).segmentIndex
}

/**
 * Format the Game Identifier
 * @param {number|string} identifier
 * @returns {string}
 */
const formatGameIdentifier = (identifier) => {
  if (!identifier) {
    return ''
  }
  if (Number.isNaN(identifier)) {
    return identifier
  }
  return `${identifier.match(/.{1,3}/g).join('-')}`
}

export {
  currentStep,
  findForeplayStepByIndex,
  formatGameIdentifier,
}



// WEBPACK FOOTER //
// ./src/lib/helper.js